export default __webpack_public_path__ + "static/media/hero-field-crew.5ca35278.png";